import React from 'react';
import ffprobe from 'ffprobe';
import ffprobeStatic from 'ffprobe-static';

const QuickUpload = ({ file }: { file: File | null }) => {
  console.log({ file });
  return <p>Episode Content</p>;
};

export { QuickUpload };
